export const BREADCRUMB_LIST = [
  { id: "1", title: "Pedidos", active: false },
  { id: "2", title: "Configuraciones", active: true },
]

// Escala de la barra de horario: 06:00 - 23:00 en minutos
export const SCALE_START = 6 * 60
export const SCALE_END = 23 * 60

export const SORT_NOMBRE = "nombre"
export const SORT_HORA = "hora"

export const PROVIDERS_TIME_START = "PROVIDERS_TIME_START"
export const PROVIDERS_TIME_END = "PROVIDERS_TIME_END"

export const SAVED_FEEDBACK_MS = 3000
